export const BOOKING_TYPE_DESCRIPTORS: { [key: string]: string } = {
  ["slot"]: "A slot membership booking",
  ["adhoc"]: "A flexible booking",
  ["weekend"]: "A weekend booking",
  ["sessional"]: "A sessional booking",
  ["special"]: "A special booking",
};

export const getBookingTypeDescriptor = (type: string): string => {
  return BOOKING_TYPE_DESCRIPTORS[type.toLowerCase()] || "Unknown booking type";
};

export const MEMBERSHIP_TYPE_DESCRIPTORS: { [key: string]: string } = {
  ["slot"]: "A slot member",
  ["adhoc"]: "A flexible member",
  ["weekend"]: "A weekend member",
  ["system"]: "A system account",
  ["prospect"]: "A prospective member",
  ["sessional"]: "A sessional membership type. This should not be used",
};

export const getMembershipTypeDescriptor = (type: string): string => {
  return MEMBERSHIP_TYPE_DESCRIPTORS[type.toLowerCase()] || "Unknown membership";
};

export const defaultButtonClasses = "hover:bg-indigo-900 hover:text-white dark:hover:bg-indigo-900 dark:hover:text-white hover:cursor-pointer";
export const secondaryButtonClasses = "hover:bg-indigo-200 hover:cursor-pointer";
export const destructiveButtonClasses = "hover:bg-red-900 hover:cursor-pointer";
export const plainLinkClasses = "hover:underline hover:cursor-pointer";
export const linkClasses = "text-blue-500 hover:text-blue-700 hover:underline hover:cursor-pointer";
export const defaultItemClasses = "bg-gray-100 border border-gray-200 shadow";
export const defaultSelectClasses = "bg-white dark:bg-gray-800 text-black dark:text-white hover:cursor-pointer hover:bg-gray-50 hover:border-gray-300 dark:hover:bg-gray-700 focus:bg-gray-50 dark:focus:bg-gray-700";